import React, { HTMLProps } from "react"

import classNames from "classnames"

import { PRODUCT_POSITION_TABLE_POSITION_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowPositionCellProps
  extends ProductPositionRowCellProps,
    Omit<HTMLProps<HTMLDivElement>, "ref"> {
  position: string
  isHidden?: boolean
  isFocused?: boolean
}

export const ProductPositionRowPositionCell = React.memo(
  React.forwardRef(
    (
      {
        position,
        isHidden,
        isFocused,
        ...rest
      }: ProductPositionRowPositionCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      if (isHidden) {
        return null
      }

      return (
        <ProductPositionTableCell
          isHeader
          key="position"
          className={classNames("position", { highlight: isFocused })}
          data-testid="position-cell"
          aria-labelledby={PRODUCT_POSITION_TABLE_POSITION_HEADER_ID}
          ref={ref}
          {...rest}
          role="rowheader"
        >
          {position}
        </ProductPositionTableCell>
      )
    }
  )
)
